// santa-core-utils package was deprecated, but we still use some functions it provided.
// this file copies the implementation of these functions so that we can remove the dependency.
// function implementations were copied from https://github.dev/wix-private/santa-core/tree/master/santa-core-utils
import _ from 'lodash';
const urlRe = /((https?\:)\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;
const TEMPLATE_REG_EXP = /\${(.*?)}/g;
function safeDecodeURIComponent(encodedURIParam) {
    try {
        return decodeURIComponent(encodedURIParam);
    }
    catch (e) {
        return encodedURIParam;
    }
}
function getParameterByName(name, urlQueries) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`, 'i');
    const results = regex.exec(_.isUndefined(urlQueries) ? window.location.search : urlQueries);
    return results === null
        ? ''
        : safeDecodeURIComponent(results[1].replace(/\+/g, ' '));
}
function baseUrl(url) {
    const parsed = parseUrl(url);
    return `${parsed.protocol}//${parsed.host}`;
}
function joinURL(...args) {
    let url = args[0];
    for (let i = 1; i < args.length; ++i) {
        url = `${url.replace(/\/$/, '')}/${args[i].replace(/^\//, '')}`;
    }
    return url;
}
function mathMap(value, x1, x2, y1, y2) {
    return (value - x1) * ((y2 - y1) / (x2 - x1)) + y1;
}
function parseUrlParams(queryString) {
    const re = /([^&=]+)=([^&]*)/g;
    const query = {};
    let param;
    while ((param = re.exec(queryString)) !== null) {
        const key = safeDecodeURIComponent(param[1]);
        const val = safeDecodeURIComponent(param[2]);
        if (!query[key]) {
            // first value for key, keep as string
            query[key] = val;
        }
        else if (_.isArray(query[key])) {
            // more than one value already, push to the array
            query[key].push(val);
        }
        else {
            // the 2nd value for the key, turn into an array
            query[key] = [query[key], val];
        }
    }
    return query;
}
function parseUrl(url) {
    if (!url) {
        return {};
    }
    const match = url.match(urlRe);
    const port = (match === null || match === void 0 ? void 0 : match[5]) || '';
    const search = (match === null || match === void 0 ? void 0 : match[8]) ? `?${match[8]}` : '';
    const ret = {
        full: url,
        protocol: (match === null || match === void 0 ? void 0 : match[2]) || 'http:',
        host: (match === null || match === void 0 ? void 0 : match[3]) + (port ? `:${port}` : ''),
        hostname: match === null || match === void 0 ? void 0 : match[3],
        port,
        path: (match === null || match === void 0 ? void 0 : match[6]) || '/',
        search,
        hash: (match === null || match === void 0 ? void 0 : match[9]) || '',
        query: {},
    };
    // fix empty hash
    if (ret.hash === '#' || ret.hash === '#!') {
        ret.hash = '';
    }
    ret.query = parseUrlParams((match === null || match === void 0 ? void 0 : match[8]) || '');
    return ret;
}
function isLocalUrl(url) {
    return /(^data)|(^blob)/.test(url);
}
function toQueryString(jsonObj, convertBool = false) {
    return _.map(jsonObj, (value, key) => toQueryParam(key, value, convertBool))
        .sort()
        .join('&');
}
function isTemplateValue(value) {
    return TEMPLATE_REG_EXP.test(value);
}
function toQueryParam(key, val, convertBool) {
    key = encodeURIComponent(key);
    if (!val && val !== 0 && val !== false) {
        return key;
    }
    key += '=';
    if (_.isArray(val)) {
        return _.map(val, (innerVal) => key + encodeURIComponent(innerVal)).join('&');
    }
    if (convertBool && typeof val === 'boolean') {
        val = val ? '1' : '0';
    }
    else if (!isTemplateValue(val)) {
        val = encodeURIComponent(val);
    }
    return key + val;
}
function buildFullUrl(urlObj, ignoreSearch = false) {
    let search = ignoreSearch ? null : urlObj.search;
    if (search) {
        search = search.replace(/^[?]/, '');
    }
    let query = search || toQueryString(urlObj.query || {});
    if (query) {
        const queryPrefix = _.includes(urlObj.path, '?') ? '&' : '?';
        query = queryPrefix + query;
    }
    return isLocalUrl(urlObj.full || '')
        ? urlObj.full
        : `${urlObj.protocol}//${urlObj.hostname}${urlObj.port ? `:${urlObj.port}` : ''}${urlObj.path}${query || ''}${urlObj.hash || ''}`;
}
function setUrlParams(url, params) {
    const urlObj = parseUrl(url);
    _.assign(urlObj.query, params);
    return buildFullUrl(urlObj, true);
}
function setUrlParam(url, paramName, value) {
    const urlParts = url.split('?');
    let paramList = [];
    let replaced = false;
    if (urlParts.length > 1) {
        paramList = urlParts[1].split('&');
        const paramIndex = _.findIndex(paramList, (param) => param.startsWith(`${paramName}=`));
        if (paramIndex !== -1) {
            paramList[paramIndex] = `${paramName}=${String(value)}`;
            replaced = true;
        }
    }
    if (!replaced) {
        paramList.push(`${paramName}=${String(value)}`);
    }
    urlParts[1] = paramList.join('&');
    url = urlParts.join('?');
    return url;
}
function removeUrlParam(url, paramName) {
    const urlObj = parseUrl(url);
    delete urlObj.search;
    if (urlObj.query) {
        delete urlObj.query[paramName];
    }
    return buildFullUrl(urlObj);
}
function isTrue(name, urlQueries) {
    return getParameterByName(name, urlQueries) === 'true';
}
export const coreUtilsLib = {
    urlUtils: {
        getParameterByName,
        joinURL,
        setUrlParams,
        setUrlParam,
        parseUrlParams,
        parseUrl,
        removeUrlParam,
        isTrue,
        baseUrl,
        buildFullUrl,
        toQueryString,
    },
    math: {
        map: mathMap,
    },
    log: console,
};
